import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Star, Map, ArrowRight } from 'lucide-react';
import axios from 'axios';
import { useCart } from '../context/CartContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PackagesPage() {
  const [packages, setPackages] = useState([]);
  const { addToCart } = useCart();

  useEffect(() => {
    axios.get(`${API}/packages`).then(res => setPackages(res.data)).catch(console.error);
  }, []);

  return (
    <div data-testid="packages-page" className="min-h-screen bg-white pt-20">
      <div className="bg-navy py-12">
        <div className="max-w-7xl mx-auto px-6">
          <p className="font-body text-sm tracking-[0.2em] uppercase text-gold font-semibold mb-3">Our Collections</p>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white mb-4">Travel Packages</h1>
          <p className="font-body text-base text-gray-400">Handcrafted packages for every kind of traveler</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Budget Packages */}
        <div className="mb-12">
          <h2 className="font-heading text-2xl font-bold text-navy mb-6 flex items-center gap-2">Budget Packages <span className="text-sm font-body text-gold bg-gold/10 px-3 py-1 rounded-full">Best Value</span></h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {packages.filter(p => p.category === 'budget').map(pkg => (
              <div key={pkg.id} data-testid={`all-pkg-${pkg.id}`} className="pkg-card bg-white rounded-3xl overflow-hidden border border-gray-100">
                <div className="relative h-48">
                  <img src={pkg.image} alt={pkg.name} className="w-full h-full object-cover" loading="lazy" />
                  <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm text-xs font-body px-3 py-1 rounded-full flex items-center gap-1 text-navy">
                    <Star className="w-3 h-3 fill-gold text-gold" />{pkg.rating}
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-lg font-semibold text-navy">{pkg.name}</h3>
                  <p className="font-body text-xs text-gray-500 mt-1 flex items-center gap-1"><Map className="w-3 h-3" />{pkg.destination} &bull; {pkg.duration}</p>
                  <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100">
                    <p className="font-heading text-xl font-bold text-gold">Rs.{pkg.price.toLocaleString('en-IN')}</p>
                    <div className="flex gap-2">
                      <button onClick={() => addToCart(pkg.id)} className="bg-gold text-white rounded-full px-4 py-2 text-xs font-body font-medium hover:bg-gold-dark transition-all">Add to Cart</button>
                      <Link to={`/packages/${pkg.id}`} className="bg-navy text-white rounded-full px-4 py-2 text-xs font-body font-medium hover:bg-navy-light transition-all flex items-center gap-1">Details <ArrowRight className="w-3 h-3" /></Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Luxury Packages */}
        <div>
          <h2 className="font-heading text-2xl font-bold text-navy mb-6 flex items-center gap-2">Luxury Packages <span className="text-sm font-body text-gold bg-gold/10 px-3 py-1 rounded-full">Premium</span></h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {packages.filter(p => p.category === 'luxury').map(pkg => (
              <div key={pkg.id} data-testid={`all-pkg-${pkg.id}`} className="pkg-card bg-white rounded-3xl overflow-hidden border border-gray-100">
                <div className="relative h-48">
                  <img src={pkg.image} alt={pkg.name} className="w-full h-full object-cover" loading="lazy" />
                  <div className="absolute top-3 left-3 bg-gold text-white text-xs font-body px-3 py-1 rounded-full">Luxury</div>
                  <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm text-xs font-body px-3 py-1 rounded-full flex items-center gap-1 text-navy">
                    <Star className="w-3 h-3 fill-gold text-gold" />{pkg.rating}
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-lg font-semibold text-navy">{pkg.name}</h3>
                  <p className="font-body text-xs text-gray-500 mt-1 flex items-center gap-1"><Map className="w-3 h-3" />{pkg.destination} &bull; {pkg.duration}</p>
                  <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100">
                    <p className="font-heading text-xl font-bold text-gold">Rs.{pkg.price.toLocaleString('en-IN')}</p>
                    <div className="flex gap-2">
                      <button onClick={() => addToCart(pkg.id)} className="bg-gold text-white rounded-full px-4 py-2 text-xs font-body font-medium hover:bg-gold-dark transition-all">Add to Cart</button>
                      <Link to={`/packages/${pkg.id}`} className="bg-navy text-white rounded-full px-4 py-2 text-xs font-body font-medium hover:bg-navy-light transition-all flex items-center gap-1">Details <ArrowRight className="w-3 h-3" /></Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
